import { SessionTiming } from '@sentry/integrations';
import * as Sentry from '@sentry/react';

import { getConfig } from '../ConfigurationService';
import { Configuration } from '../ConfigurationService/ConfigurationService';
import ConsentService, { ConsentCategory } from '../ConsentService';

export const initialize = () => {
  const sentryEnabled = environment.SENTRY_ENABLED && ConsentService.isCategoryConsented(ConsentCategory.Necessary);
  const sentryDsn = environment.SENTRY_FRONTEND_DSN;
  const sentryEnvironment = environment.SENTRY_ENVIRONMENT;

  if (sentryEnabled) {
    Sentry.init({
      dsn: sentryDsn,
      release: environment.BUILD_IDENTIFIER,
      environment: sentryEnvironment,
      ignoreErrors: [
        'ResizeObserver loop limit exceeded',
        'ResizeObserver loop completed with undelivered notifications',
        'InternalServerError',
        'TypeError: Failed to fetch',
      ],
      integrations: (defaultIntegrations) => [...defaultIntegrations, new SessionTiming()],
      initialScope: {
        tags: { account: getConfig(Configuration.AccountId) },
        user: {
          id: getConfig(Configuration.EmployeeId).toString(),
          account: getConfig(Configuration.AccountId),
        },
      },
    });
  }
};

export const logError = (error: any, data?: Record<string, any>) => {
  // eslint-disable-next-line no-console
  console.error(error);
  const sentryEnabled = environment.SENTRY_ENABLED && ConsentService.isCategoryConsented(ConsentCategory.Necessary);

  if (!sentryEnabled) {
    return;
  }

  Sentry.withScope((scope) => {
    scope.setExtra('data', data);

    Sentry.captureException(error);
  });
};
